import { Typography } from '@customink/pigment-react';
import { type ProjectItem } from '@customink/project-service-react-components';

import { ProjectItemUnitPrice } from './ProjectItemUnitPrice';

type ProjectItemQuantityWithPriceProps = {
  item: ProjectItem;
};

export const ProjectItemQuantityWithPrice = ({
  item,
}: ProjectItemQuantityWithPriceProps) => {
  return (
    <Typography variant="uiTextSmall">
      Qty {item.totalQuantity || '0'} @ <ProjectItemUnitPrice item={item} />
    </Typography>
  );
};
